<template>
  <div
    class="tw-fixed tw-inset-0 tw-z-modal-backdrop tw-h-full tw-w-full tw-overflow-y-auto tw-overflow-x-hidden tw-bg-background-medium tw-bg-opacity-70"
  >
    <slot></slot>
  </div>
</template>
